const DEFAULT_CARD_PAYMENT_PROVIDERS = ['stripe', 'paypal'];

export function isPaymentProviderAvailable(availablePaymentProviders, provider) {
  const list =
    availablePaymentProviders == null
      ? DEFAULT_CARD_PAYMENT_PROVIDERS
      : availablePaymentProviders;
  return list.indexOf(provider) !== -1;
}
